// handle subscription frequency selector changing
const frequencySelector = document.querySelector('.main-product select[name="selling_plan_freq"]');
if (frequencySelector) {
    frequencySelector.addEventListener('change', function() {
        console.log('changed');
        let value = this.value
        let parent = this.closest('.subscribe-container');
        let sellingPlanDummyInput = parent.querySelector('input[name="selling_plan_dummy"]');
        console.log(sellingPlanDummyInput);
        sellingPlanDummyInput.value = value;
        sellingPlanDummyInput.dispatchEvent(new Event('change'));
    });
}


// handle switching of OTP, Subscribe and Save, and Frequency
// to update main selling_plan input within form
const sellingPlanDummyInputs = document.querySelectorAll('.main-product .subscription-selector-container input[name="selling_plan_dummy"]');
if (sellingPlanDummyInputs) {
    sellingPlanDummyInputs.forEach(input => {
        input.addEventListener('change', function() {
            const sellingPlanInput = document.querySelector('.main-product input[name="selling_plan"]');
            const selectedSellingPlan = document.querySelector('.main-product input[name="selling_plan_dummy"]:checked')
            sellingPlanInput.value = selectedSellingPlan.value;
        });
    });
}

// update price when changing variant
const mainProductForms = document.querySelectorAll('.main-product form');
if (mainProductForms) {

    mainProductForms.forEach(mainProductForm => {
        mainProductForm.addEventListener('variant:change', function(e) {
    
            let fullPricePence = e.detail.variant.price;
            let subscriptionPricePence = e.detail.variant.selling_plan_allocations[0].price;
    
            let servingSize = 52;
            if (e.detail.variant.options.includes('250g')) {
                servingSize = 13;
            }
    
            let fullPrice = theme.Currency.formatMoney(fullPricePence, theme.settings.moneyFormat);
            let subscriptionPrice = theme.Currency.formatMoney(subscriptionPricePence, theme.settings.moneyFormat);
            let fullPricePerServing = theme.Currency.formatMoney(fullPricePence / servingSize, theme.settings.moneyFormat);
            let subscriptionPricePerServing = theme.Currency.formatMoney(subscriptionPricePence / servingSize, theme.settings.moneyFormat);
    
            let parentNode = this.closest('.main-product');
            let fullPriceEl = parentNode.querySelector('.otp-container .price');
            let subscriptionPriceEl = parentNode.querySelector('.subscribe-container .price');
            let fullPricePerEl = parentNode.querySelector('.otp-container .price-per-serving span');
            let subscriptionPricePerEl = parentNode.querySelector('.subscribe-container .price-per-serving span');
    
            if (fullPriceEl) {
                fullPriceEl.innerHTML = fullPrice;
            }
            if (subscriptionPriceEl) {
                subscriptionPriceEl.innerHTML = subscriptionPrice;
            }
            if (fullPricePerEl) {
                fullPricePerEl.innerHTML = fullPricePerServing;
            }
            if (subscriptionPricePerEl) {
                subscriptionPricePerEl.innerHTML = subscriptionPricePerServing;
            }
        });
    })

}



// select first available grind when changing type
const selectFirstAvailableGrind = function() {
    let typeInputs = document.querySelectorAll('.main-product fieldset[data-option-slug="type"] label');

    typeInputs.forEach(typeInput => {

        typeInput.addEventListener('click', function() {
            
            setTimeout(() => {
                const grindInputs = document.querySelectorAll('.main-product fieldset[data-option-slug="grind-type"] input');
                let foundFirstInput = false;

                grindInputs.forEach(grindInput => {
                    if (!grindInput.disabled) {
                        if (!foundFirstInput) {
                            grindInput.nextElementSibling.click();
                            foundFirstInput = true;
                        }
                    }
                });
            }, 500);

        });
    });

}

selectFirstAvailableGrind();
if (mainProductForms) {
    mainProductForms.forEach(mainProductForm => {
        mainProductForm.addEventListener('variant:change', function(e) {
            selectFirstAvailableGrind();
        });
    })
}







